<template>
    <div>
        <div class="form-group">
            <label>API Key</label>
            <input type="text" class="form-control" v-model="data.apiKey">
        </div>
        <div class="form-group">
            <label>Board Token</label>
            <input type="text" class="form-control" v-model="data.boardToken">
        </div>
        <div class="form-group">
            <label>Mapped URL Token</label>
            <input type="text" class="form-control" v-model="data.mappedUrlToken">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>